const slideDown = ( target, duration = 300 ) => {
    target.style.display = 'grid';
    let height = target.offsetHeight;
    target.style.height = 0;
    target.offsetHeight;
    target.style.transition = 'height 0.3s ease-in-out;';
    target.style.height = height + 'px';
    window.setTimeout( () => {
        target.style.removeProperty( 'height' );
    }, duration );
}

const slideUp = ( target, duration = 300 ) => {
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.height = 0;
    window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty( 'height' );
    }, duration );
}

const slideToggle = ( target, duration = 300 ) => {
    if ( window.getComputedStyle( target ).display === 'none' ) {
        return slideDown( target, duration );
    } else {
        return slideUp( target, duration );
    }
}

// we have different element for submenus toggle in editor and admin panel
function navInit( toggleClass ) {
    const menuOpenButton = header.querySelector( ':scope .wp-block-navigation__responsive-container-open' );
    const menuCloseButton = header.querySelector( ':scope .wp-block-navigation__responsive-container-close' );
    const searchButton = header.querySelector( ':scope .site-header__search-container summary' );
    const headerNavigationToggles = header.querySelectorAll( `:scope ${ toggleClass }` );
    const searchForm = header.querySelector( ':scope .wp-block-search' );

    // add classes to the header for indicating show/hide state of the menu and add relative styles
    if ( menuOpenButton && menuCloseButton ) {
        menuOpenButton.addEventListener( 'click', () => {
            if ( header.classList.contains( 'site-header--search-open' ) ) {
                searchButton.click();
            }

            header.classList.add( 'site-header--menu-open' );

            if ( headerWrapper.classList.contains( 'is-style-nyg-starter-dark' ) ) {
                headerWrapper.classList.add( 'was-style-nyg-starter-dark' );
            }

            if ( headerWrapper.classList.contains('is-style-splitkon-beige') ) {
                headerWrapper.classList.add( 'was-style-splitkon-beige' );
            }

            headerWrapper.classList.add( 'is-style-nyg-starter-dark' );
            headerWrapper.classList.remove( 'is-style-splitkon-beige' );
        } );

        menuCloseButton.addEventListener( 'click', () => {
            header.classList.remove( 'site-header--menu-open' );
            if ( !headerWrapper.classList.contains( 'was-style-nyg-starter-dark' ) ) {
                headerWrapper.classList.remove( 'is-style-nyg-starter-dark' );
            }

            if ( headerWrapper.classList.contains( 'was-style-splitkon-beige' ) ) {
                headerWrapper.classList.add( 'is-style-splitkon-beige' );
            }
        } );
    }

    // add classes to the header for indicating show/hide state of the search and add relative styles
    if ( searchButton ) {
        searchButton.addEventListener( 'click', () => {
            header.classList.toggle( 'site-header--search-open' );

            if( header.classList.contains( 'site-header--search-open' ) ) {

                if ( headerWrapper.classList.contains('is-style-nyg-starter-dark') ) {
                    headerWrapper.classList.add( 'was-style-nyg-starter-dark' );
                }

                if ( headerWrapper.classList.contains('is-style-splitkon-beige') ) {
                    headerWrapper.classList.add( 'was-style-splitkon-beige' );
                }

                headerWrapper.classList.add( 'is-style-nyg-starter-dark' );
                headerWrapper.classList.remove( 'is-style-splitkon-beige' );
            } else {
                if ( !headerWrapper.classList.contains( 'was-style-nyg-starter-dark' ) ) {
                    headerWrapper.classList.remove( 'is-style-nyg-starter-dark' );
                }

                if ( headerWrapper.classList.contains( 'was-style-splitkon-beige' ) ) {
                    headerWrapper.classList.add( 'is-style-style-splitkon-beige' );
                }
            }

            if ( header.classList.contains( 'site-header--menu-open' ) ) {
                menuCloseButton.click();
            }

            document.documentElement.classList.toggle( 'has-modal-open' );
        } );
    }

    // open/close navigation submenus
    if ( headerNavigationToggles ) {
        headerNavigationToggles.forEach( toggle => {
            toggle.addEventListener( 'mousedown', ( e ) => {
                e.preventDefault();

                const li = toggle.parentNode;

                li.classList.toggle( 'nav-submenu-active' );
                slideToggle( li.querySelector( ':scope .wp-block-navigation__submenu-container' ) );
            } );
        } );
    }

    // search form ajax
    if ( searchForm ) {
        const searchResultsWrapper = searchForm.nextElementSibling;
        const searchResultsTotal = searchResultsWrapper.firstElementChild;
        const searchResults = searchResultsTotal.nextElementSibling

        searchForm.addEventListener( 'submit', ( e ) => {
            e.preventDefault();
            searchResults.innerHTML = '';

            const searchInput = searchForm.querySelector( ':scope .wp-block-search__input' );
            const searchQuery = searchInput.value.trim();

            if ( searchQuery ) {
                let request = new XMLHttpRequest();
                request.onreadystatechange = () => {
                    if ( request.readyState === 4 ) {
                        if ( request.status === 200 ) {
                            const response = JSON.parse( request.response );

                            if ( response.data.results ) {
                                searchResults.innerHTML = response.data.results;
                            }

                            searchResultsTotal.innerHTML = response.data.total;
                            searchResultsWrapper.classList.add( 'site-header__search-results-wrapper--active' );
                        }
                    }
                };

                request.open( "GET", splitkon.ajax_url + `?action=splitkon_search&s=${ searchQuery }`, true );
                request.send();
            }
        } );
    }
}

const headerWrapper = document.querySelector( '.site-header-wrapper' );
const header = document.querySelector( '.site-header' );

// this delays the header show up for a bit to prevent flickering
if ( headerWrapper && document.querySelector( '.entry-content' ) ) {
    setTimeout( () => {
        headerWrapper.classList.remove( 'site-header-wrapper--hidden' );
    }, 75 );
}

// we don't have header in page editor
if ( header ) {
    // with this, we check whether we are on the front page or in the editor
    if ( document.querySelector( '.entry-content' ) ) {
        navInit( '.wp-block-navigation-submenu__toggle' );
    } else {
        // we add bigger delay for the editor because it takes some time to load
        setTimeout( () => {
            navInit( '.wp-block-navigation__submenu-icon' );
        }, 2000 );
    }
}
